import { Rating } from '../../primitives/Rating';

import { ExternalLink } from './ExternalLink';
import { FollowingPill } from './FollowingPill';
import type { SummaryValues } from './summary-form';
import { SummaryRow } from './SummaryRow';
import { UnknownValue } from './UnknownValue';

/** Read view of the partner summary: rating, Instagram follow state and HubSpot link. */
export function CoMarketingSummaryView({ values }: { values: SummaryValues }) {
  const { comarketingRating: rating, followingOnInstagram, hubspotUrl } = values;
  return (
    <>
      <SummaryRow label="Rating">
        <Rating value={rating} size={16} />
        {rating === null ? (
          <UnknownValue>Not rated</UnknownValue>
        ) : (
          <span className="nb-tabular" style={{ fontWeight: 700 }}>
            {rating}
            <span style={{ color: 'var(--nb-muted)', fontWeight: 500 }}> / 5</span>
          </span>
        )}
      </SummaryRow>
      <SummaryRow label="Following on IG">
        <FollowingPill value={followingOnInstagram} />
      </SummaryRow>
      <SummaryRow label="HubSpot">
        {hubspotUrl ? (
          <ExternalLink href={hubspotUrl}>Open HubSpot record</ExternalLink>
        ) : (
          <UnknownValue>No record linked</UnknownValue>
        )}
      </SummaryRow>
    </>
  );
}
